import React from 'react';
import { Search, X, Mic } from 'lucide-react';

const SearchBar = ({ 
  value, 
  onChange, 
  onClear,
  placeholder = "Buscar platillos...",
  autoFocus = false
}) => {
  return (
    <div 
      className="relative max-w-md mx-auto mb-6"
      data-testid="search-container"
    >
      {/* Search Icon */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
        <Search className="w-5 h-5 text-slate-400" />
      </div>
      
      {/* Input */}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="
          w-full bg-slate-800/90 text-white placeholder-slate-400 
          pl-12 pr-20 py-3.5 rounded-2xl 
          border border-white/10 
          focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 
          outline-none transition-all
          text-base
        "
        data-testid="product-search-input"
      />

      {/* Right side buttons */}
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {/* Clear button */}
        {value && (
          <button
            onClick={() => {
              onChange('');
              onClear?.();
            }}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
            data-testid="search-clear-btn"
          >
            <X className="w-4 h-4 text-slate-400" />
          </button>
        )}
        
        {/* Voice search button (decorative) */}
        <button
          className="p-2 hover:bg-white/10 rounded-full transition-colors hidden sm:flex"
          data-testid="voice-search-btn"
        >
          <Mic className="w-4 h-4 text-cyan-400" />
        </button>
      </div>

      {/* Glow effect on focus */}
      <div className="absolute inset-0 rounded-2xl bg-cyan-400/5 opacity-0 focus-within:opacity-100 transition-opacity pointer-events-none" />
    </div>
  );
};

export default SearchBar;
